import { Directive } from '@angular/core';

@Directive({
    selector: '[listItem]',
    standalone: false
})
export class CheckListItemDirective {}
